import React, { Component } from "react";
import Storage from "../../../../services/storage.service";
import Settings from "../../../../services/settings.service";
import Numbers from "../../../../services/numbers.service";
import MNPForm from "./mnp-form.component";
import VerfiyMNP from "./verify-mnp.component";
import Phones from "google-libphonenumber";
import Countries from "../../../../services/countries.service";
import StmSummary from "../../../shared/storefront-summary";
import SpinnerTimeLoader from "../../../shared/timeLoading";

export default class MNP extends Component {
  phoneUtil = Phones.PhoneNumberUtil.getInstance();

  state = {
    numberScreenStatus: null,
    show_mnp_otp_form: false,
    loading: false,
    otpError: false,
    form: {
      formValid: false,
      mnp_number: {
        value: "",
        tuched: false,
        validation: false,
        rules: Settings.formats.phonenumber,
        required: true,
        type: "phone",
        // rulesType: 'all' //values => any | all
      },
      operator_id: {
        value: "",
        tuched: false,
        validation: false,
        // rules: 'required',
        rules: Settings.formats.notEmpty,
        required: true,
        // rulesType: 'all' //values => any | all
      },
      country_select: {
        value: "SA",
        iso: 966,
        tuched: false,
        validation: false,
        rules: Settings.formats.country,
        required: false,
        type: "country",
        // rulesType: 'all' //values => any | all
      },
      contact_number: {
        value: "",
        tuched: false,
        validation: false,
        rules: Settings.formats.notEmpty,
        required: false,
        type: "phone",
        dependency: "country_select",
        // rulesType: 'all' //values => any | all
      },
      validId: {
        value: "",
        tuched: false,
        validation: false,
        rules: Settings.formats.notEmpty,
        required: true,
        type: "checkbox",
        dependency: "country_select",
      },
      terms: {
        value: "",
        tuched: false,
        validation: false,
        rules: Settings.formats.notEmpty,
        required: true,
        type: "checkbox",
        dependency: "country_select",
      },
    },
    otpForm: {
      formValid: false,
      otp: {
        value: "",
        tuched: false,
        validation: false,
        rules: Settings.formats.otpCode,
        required: true,
      },
    },
    showMsg: null,
  };

  updateFieled = (event, form, type = "text") => {
    let newState = {};
    let elem = event.target;
    let formKeys = Object.keys(this.state[form]);
    for (let key of formKeys) {
      if (typeof this.state[form][key] === "object") {
        if (Array.isArray(this.state[form][key])) {
          newState[key] = this.state[form][key].slice();
        } else {
          newState[key] = { ...this.state[form][key] };
        }

        if (elem.name === key) {
          if (type === "select") {
            newState[key].value = elem.selectedOptions[0].value;
          } else if (type === "checkbox") {
            newState[key].value = elem.checked;
          } else {
            newState[key].value = elem.value;
          }

          newState[key].tuched = true;
          let required = newState[key].required;
          let valid;
          if (required && !newState[key]["value"]) {
            valid = false;
          } else {
            // all
            valid = true;

            let value = newState[key]["value"];
            let type = newState[key]["type"];

            if (type === "phone") {
              let testCondition = Settings.formats.phonenumber.test(value);
              if (key === "contact_number") {
                testCondition = Settings.formats.phonenumberContact.test(value);
              }
              if (value.length > 6 && testCondition) {
                let dependency_id = newState[key]["dependency"];
                let country = null;
                if (dependency_id) {
                  if (newState[dependency_id]["type"] === "country") {
                    // let dependency = newState[key]["country"];
                    country =
                      Countries.Countries[newState[dependency_id]["value"]];
                    newState[dependency_id].iso =
                      country.CountryCode.substring(1);
                  } else {
                    let dependency = newState[dependency_id]["value"];
                    country = Countries.Countries[dependency];
                    newState[dependency_id].iso =
                      country.CountryCode.substring(1);
                  }
                } else {
                  country = Countries.Countries["SA"];
                }

                if (country && country.ISO_2Code) {
                  let number = this.phoneUtil.parse(value, country.ISO_2Code);
                  valid = this.phoneUtil.isValidNumber(number);
                } else {
                  valid = Settings.formats.phonenumber.test(value);
                }
              } else if (value.length === 0 && !required) {
                valid = true;
              } else {
                valid = false;
              }
            }
          }

          newState[key].validation = valid;
        }
      } else {
        newState[key] = this.state[form][key];
      }
    }
    let formInputKeys = formKeys.slice(1);
    let formValid = true;
    for (let key of formInputKeys) {
      if (newState[key].required && newState[key].validation) {
        formValid = formValid && true;
      } else if (
        !newState[key].required &&
        newState[key].tuched &&
        newState[key].validation
      ) {
        formValid = formValid && true;
      } else if (!newState[key].required && !newState[key].tuched) {
        formValid = formValid && true;
      } else {
        formValid = formValid && false;
      }
      // if(newState[key].required && newState[key].validation)
    }
    newState["formValid"] = formValid;
    this.setState({
      [form]: newState,
    });
  };

  mnpFormSubmit = () => {
    Numbers.keepMnpRequestInfo(this.state.form);
    this.setState({
      loading: true,
    });
    Numbers.requestMnpOtp()
      .then((result) => {
        Storage.set("move_to_mnp_otp", true);

        this.setState({
          loading: false,
        });
      })
      .catch((error) => {
        Storage.clear("mnp_info");

        this.setState({
          loading: false,
        });
      });

    Storage.set("choose_mnp", true, true);
  };

  otpFormSubmit = () => {
    this.setState({
      loading: true,
    });
    Storage.clear("promotionErrorStatus");
    Storage.set("promotionErrorStatus", true, true);
    Numbers.submitMnpRequestAndNext(this.state.otpForm)
      .then((res) => {
        if (res) {
          Storage.clear("mnp_info");
          Storage.clear("move_to_mnp_otp");
          // this.setState({
          // 	loading: false,
          //   });
        } else {
          this.setState({
            otpError: true,
            loading: false,
            show_mnp_otp_form: true,
          });
        }
        Storage.clear("promotionErrorStatus");
      })
      .catch(() => {
        Storage.clear("promotionErrorStatus");
        this.setState({
          loading: false,
        });
      });
  };

  subscriptions = [];
  componentWillUnmount() {
    if (this.subscriptions) {
      for (let subscription of this.subscriptions) {
        subscription.unsubscribe();
      }
    }
  }

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("move_to_mnp_otp").subscribe((data) => {
        this.setState({
          show_mnp_otp_form: data,
        });
      })
    );
    if (Storage.get("mnp_info", true)) {
      Storage.set("move_to_mnp_otp", true);
    }
  }

  handleOtpForm = (value) => {
    const updatedState = { ...this.state };
    if (value.length === 6) {
      updatedState.otpForm.formValid = true;
    } else {
      updatedState.otpForm.formValid = false;
    }
    updatedState.otpForm.otp.value = value;
    this.setState({ state: updatedState, otpError: false });
  };

  handleChooseAgain = () => {
    this.setState({
      show_mnp_otp_form: false,
    });
  };

  handleOtpError = (value) => {
    this.setState({
      otpError: value,
    });
  };

  handleClearError = () => {
    this.setState({
      otpError: false,
    });
  };
  
  render() {
    let content = (
      <div>
        <div className="left-column">
          <div className="storefront-two-col-pg">
            <div className="mnp-wrapper">
              <>
                {this.state.show_mnp_otp_form ? (
                  <VerfiyMNP
                    updateFieled={this.updateFieled}
                    state={this.state.otpForm}
                    submit={this.otpFormSubmit}
                    otpError={this.state.otpError}
                    handleOtpForm={this.handleOtpForm}
                    handleOtpError={this.handleOtpError}
                    handleClearError={this.handleClearError}
                  />
                ) : (
                  <MNPForm
                    updateFieled={this.updateFieled}
                    state={this.state.form}
                    submit={this.mnpFormSubmit}
                  />
                )}
              </>
            </div>
            <StmSummary />
          </div>
        </div>
        {/* <div className="right-column hidden-right-column">
					<MnpRequestText />
				</div> */}
      </div>
    );
    if (this.state.loading) {
      content = <SpinnerTimeLoader />;
    }
    if (this.state.showMsg) {
      content = this.state.showMsg;
    }
    return content;
  }
}
